<template>
	<TheTable
		v-if="tableData"
		:tableData="tableData"
		:loading="loading"
		:defaultSort="{ prop: 'createdDate', order: 'descending' }"
		:showMaxRows="8"
		@rowClick="goToDetailPage"
		@rowClickNewTab="goToDetailPageNewTab"
	>
		<el-table-column prop="state" label="Entscheidung" width="140" sortable>
			<template #default="scope">
				<div class="has-status" :class="`has-status--${$getStateColor('decision', scope.row.decisionState)}`">
					{{ $getStateFullLabel('decision', scope.row.decisionState) }}
				</div>
			</template>
		</el-table-column>
		<el-table-column prop="hid" label="ID" width="100" sortable />
		<el-table-column prop="" label="Datum" width="100" sortable>
			<template #default="scope">
				<span>{{ scope.row.decidedDate ? $formatDate(scope.row.decidedDate) : '-' }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="" label="Titel" min-width="100" sortable>
			<template #default="scope">
				<span>{{ displayedCaseTitle(scope.row) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="" label="Name" width="160" sortable>
			<template #default="scope">
				<span>{{ scope.row.user.firstName }} {{ scope.row.user.lastName }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="role.name" label="Gruppe" width="130" sortable />
		<el-table-column prop="" label="Begründung" min-width="200" sortable>
			<template #default="scope">
				<span>{{ scope.row.reasonText }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="" label="Ent. bis" width="120" sortable>
			<template #default="scope">
				<span>{{
					scope.row.decisionType === SendCaseType.SmallSenate
						? $formatDate(displayedPreVoteEndDate(scope.row))
						: $formatDate(displayedVoteEndDate(scope.row))
				}}</span>
			</template>
		</el-table-column>
	</TheTable>

	<TablePagination :currentLength="tableData.length" :totalMaxVal="totalCount" @loadNextPage="$emit('loadNextPage')" />
</template>

<script lang="ts">
import { Paperclip } from '@element-plus/icons-vue';
import { defineComponent, PropType } from 'vue';
import { DecisionResponse, SendCaseType } from '../../types/types';
import TheTable from '../TheTable.vue';
import TablePagination from './TablePagination.vue';

export default defineComponent({
	name: 'DecisionsTable',
	components: {
		Paperclip,
		TablePagination,
		TheTable,
	},
	data() {
		return {
			SendCaseType,
		};
	},
	props: {
		tableData: {
			type: Array as PropType<DecisionResponse[]>,
			default: [],
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		totalCount: {
			type: Number,
			default: 0,
		},
		caseTitle: {
			type: String,
			default: '',
		},
		preVoteEndDate: {
			type: String,
			default: '',
		},
		voteEndDate: {
			type: String,
			default: '',
		},
	},
	emits: ['loadNextPage'],
	methods: {
		goToDetailPage(row: DecisionResponse) {
			this.$router.push({ name: 'EntscheidungDetail', params: { id: String(row.id) } });
		},
		goToDetailPageNewTab(row: DecisionResponse) {
			window.open(this.$router.resolve({ name: 'EntscheidungDetail', params: { id: String(row.id) } }).href, '_blank');
		},
		displayedCaseTitle(row) {
			return this.caseTitle ? this.caseTitle : row.case.title;
		},
		displayedPreVoteEndDate(row) {
			return this.preVoteEndDate ? this.preVoteEndDate : row.case?.preVoteEndDate;
		},
		displayedVoteEndDate(row) {
			return this.voteEndDate ? this.voteEndDate : row.case?.voteEndDate;
		},
	},
});
</script>

<style lang="scss"></style>
